var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" ● "),_vm._l((_vm.links),function(ref){
var name = ref.name;
var href = ref.href;
var isCommunity = ref.isCommunity;
return _c('a',{key:name,staticStyle:{"color":"inherit"},attrs:{"href":href,"target":isCommunity ? '_blank' : ''}},[_vm._v(" "+_vm._s(name)+" ● ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }